export const convertToShortDate = (date: string) => {
  const curdate = new Date(date);
  return curdate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    weekday: "short",
  });
};

export function formatDateTime(dateTimeString: string): string {
  const date = new Date(dateTimeString);

  const optionsDate: Intl.DateTimeFormatOptions = {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  };

  const optionsTime: Intl.DateTimeFormatOptions = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  };

  const formattedDate = date.toLocaleDateString("en-US", optionsDate);
  const formattedTime = date.toLocaleTimeString("en-US", optionsTime);

  return `${formattedDate} ${formattedTime}`;
}

export function getAppointmentDateFormat(date = new Date()) {
  // Create a new Date object if date is not provided
  const today = new Date(date);

  // Get the year, month, and day from the Date object
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(today.getDate()).padStart(2, "0");

  // Format the date as YYYY-MM-DD
  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
}

export function convertTo12HourFormat(time) {
  // Split the time string into components
  const [hours, minutes, seconds] = time.split(":").map(Number);

  // Determine AM or PM suffix
  const period = hours >= 12 ? "PM" : "AM";

  // Convert hours to 12-hour format
  const adjustedHours = hours % 12 || 12; // 0 or 12 hours should be converted to 12

  // Format the hours and minutes with leading zeros if necessary
  const formattedHours = String(adjustedHours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");

  // Return the formatted time
  return `${formattedHours}:${formattedMinutes}${period}`;
}

export const formatMessageDate = (dateString) => {
const date = new Date(dateString);
const now = new Date();

const isToday =
  date.getDate() === now.getDate() &&
  date.getMonth() === now.getMonth() &&
  date.getFullYear() === now.getFullYear();

const isYesterday =
  date.getDate() === now.getDate() - 1 &&
  date.getMonth() === now.getMonth() &&
  date.getFullYear() === now.getFullYear();

const hours = date.getHours().toString().padStart(2, "0");
const minutes = date.getMinutes().toString().padStart(2, "0");
const timeString = `${hours}:${minutes}`;

if (isToday) {
  return timeString;
} else if (isYesterday) {
  return `Yesterday - ${timeString}`;
} else {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()];
  const day = date.getDate();
  const daySuffix = getDaySuffix(day);
  return `${month} ${day}${daySuffix} - ${timeString}`;
}
};

const getDaySuffix = (day) => {
  if (day > 3 && day < 21) return "th"; // catches 11th, 12th, 13th
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};


export const convertToLongDate = (date: string) => {
  const curdate = new Date(date);
  return curdate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};